export const ALL_PERMISSIONS = {
  COMPANIES: {
    GET_PAGINATE: {
      method: "GET",
      apiPath: "/api/v1/companies",
      module: "COMPANIES",
    },
    CREATE: {
      method: "POST",
      apiPath: "/api/v1/companies",
      module: "COMPANIES",
    },
    UPDATE: {
      method: "PATCH",
      apiPath: "/api/v1/companies/:id",
      module: "COMPANIES",
    },
    DELETE: {
      method: "DELETE",
      apiPath: "/api/v1/companies/:id",
      module: "COMPANIES",
    },
  },
  JOBS: {
    GET_PAGINATE: { method: "GET", apiPath: "/api/v1/jobs", module: "JOBS" },
    CREATE: { method: "POST", apiPath: "/api/v1/jobs", module: "JOBS" },
    UPDATE: { method: "PATCH", apiPath: "/api/v1/jobs/:id", module: "JOBS" },
    DELETE: { method: "DELETE", apiPath: "/api/v1/jobs/:id", module: "JOBS" },
  },
  PERMISSIONS: {
    GET_PAGINATE: {
      method: "GET",
      apiPath: "/api/v1/permissions",
      module: "PERMISSIONS",
    },
    CREATE: {
      method: "POST",
      apiPath: "/api/v1/permissions",
      module: "PERMISSIONS",
    },
    UPDATE: {
      method: "PATCH",
      apiPath: "/api/v1/permissions/:id",
      module: "PERMISSIONS",
    },
    DELETE: {
      method: "DELETE",
      apiPath: "/api/v1/permissions/:id",
      module: "PERMISSIONS",
    },
  },
  RESUMES: {
    GET_PAGINATE: {
      method: "GET",
      apiPath: "/api/v1/resumes",
      module: "RESUMES",
    },
    CREATE: { method: "POST", apiPath: "/api/v1/resumes", module: "RESUMES" },
    UPDATE: {
      method: "PATCH",
      apiPath: "/api/v1/resumes/:id",
      module: "RESUMES",
    },
    DELETE: {
      method: "DELETE",
      apiPath: "/api/v1/resumes/:id",
      module: "RESUMES",
    },
  },
  ROLES: {
    GET_PAGINATE: { method: "GET", apiPath: "/api/v1/roles", module: "ROLES" },
    CREATE: { method: "POST", apiPath: "/api/v1/roles", module: "ROLES" },
    UPDATE: { method: "PATCH", apiPath: "/api/v1/roles/:id", module: "ROLES" },
    DELETE: { method: "DELETE", apiPath: "/api/v1/roles/:id", module: "ROLES" },
  },
  USERS: {
    GET_PAGINATE: { method: "GET", apiPath: "/api/v1/users", module: "USERS" },
    CREATE: { method: "POST", apiPath: "/api/v1/users", module: "USERS" },
    UPDATE: { method: "PATCH", apiPath: "/api/v1/users/:id", module: "USERS" },
    DELETE: { method: "DELETE", apiPath: "/api/v1/users/:id", module: "USERS" },
  },
  EMAIL_FOLLOW: {
    GET_PAGINATE: { method: "GET", apiPath: "/api/v1/email-follow", module: "EMAIL FOLLOW" },
    CREATE: { method: "POST", apiPath: "/api/v1/email-follow", module: "EMAIL FOLLOW" },
    UPDATE: { method: "PATCH", apiPath: "/api/v1/email-follow/:id", module: "EMAIL FOLLOW" },
    DELETE: { method: "DELETE", apiPath: "/api/v1/email-follow/:id", module: "EMAIL FOLLOW" },
  },
};

// export const ALL_MODULES = {
//   AUTH: "AUTH",
//   COMPANIES: "COMPANIES",
//   FILES: "FILES",
//   JOBS: "JOBS",
//   PERMISSIONS: "PERMISSIONS",
//   RESUMES: "RESUMES",
//   ROLES: "ROLES",
//   USERS: "USERS",
//   SUBSCRIBERS: "SUBSCRIBERS",
// };

export const ALL_MODULES = [
  { value: "AUTH", label: "AUTH" },
  { value: "USERS", label: "USERS" },
  { value: "POSTS", label: "POSTS" },
  { value: "TOPICS", label: "TOPICS" },
  { value: "ROLES", label: "ROLES" },
  { value: "FILES", label: "FILES" },
  { value: "CATEGORIES", label: "CATEGORIES" },
  { value: "DASHBOARD", label: "DASHBOARD" },
  { value: "PERMISSIONS", label: "PERMISSIONS" },
  { value: "COMMENTS", label: "COMMENTS" },
  { value: "EMAIL FOLLOW", label: "EMAIL FOLLOW" },
  { value: "PODCAST", label: "PODCAST" },
  { value: "UPLOAD", label: "UPLOAD" },
];

export const ALL_METHOD = [
  { value: "GET", label: "GET" },
  { value: "POST", label: "POST" },
  { value: "PUT", label: "PUT" },
  { value: "PATCH", label: "PATCH" },
  { value: "DELETE", label: "DELETE" },
];

export const ALL_GENDER: {
  value: string;
  label: string;
}[] = [
  { value: "MALE", label: "MALE" },
  { value: "FEMALE", label: "FEMALE" },
];

export const ALL_ACTIVE: {
  value: boolean;
  label: string;
}[] = [
  { value: true, label: "ACTIVE" },
  { value: false, label: "NO" },
];
